export default __webpack_public_path__ + "static/media/loadingmobile2.610406ce.gif";